export var IdTournamentProgression;
(function (IdTournamentProgression) {
    IdTournamentProgression["Demoted"] = "Demoted";
    IdTournamentProgression["Promoted"] = "Promoted";
    IdTournamentProgression["NoProgression"] = "NoProgression";
})(IdTournamentProgression || (IdTournamentProgression = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/IdTournamentProgression.ts
// module id = 425
// module chunks = 3